import React, { Component } from 'react';
import { Header, Footer, NewsArticleCard, NewsArticleSummary } from '../../components';
import objectFitImages from 'object-fit-images';
import _ from 'lodash';
import moment from 'moment';

class index extends Component {

  state = {
    news: [],
    featuredNews: {},
  }

  componentDidMount = () => {
    fetch('/en/news/json/')
      .then(response => {
        if(response.ok) {
          return response.json()
        } else {
          throw new Error('Something went wrong ...');
        }
      })
      .then(data => {
        this.setState({ 
          news: data.news,
          featuredNews: data.featuredNews[0]
        })
      })
    objectFitImages();
  }

  render() {
    const { news , featuredNews } = this.state
    return (
      <div className="news-container">
        <div className="container">
          <div className="feature-news-image-anchor">
            <div className="feature-news-media1 zoomable" style={{ backgroundImage: `url(${featuredNews.media})` }} />
            <div className="feature-news-article-box">
              <NewsArticleSummary
                title={featuredNews.title}
                dateString={moment(_.get(featuredNews.createdAt, 'date')).format('MMMM D ,YYYY')}
                excerpt={featuredNews.excerpt}
                to={`/en/news/${featuredNews.id}/${featuredNews.slug}`}
              />
            </div>
          </div>


          <div className="related-news-column">
            <div className="row">
                { 
                  _.map( news, (perNew) => 
                    <div className="col-xl-4">
                      <NewsArticleCard 
                        media={perNew.media2}
                        title={perNew.title}
                        dateString={moment(_.get(perNew.createdAt, 'date')).format('MMMM D ,YYYY')}
                        to={`/en/news/${perNew.id}/${perNew.slug}`}
                        excerpt={perNew.excerpt}
                      />
                  </div>
                  )
                }
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default index;


// WEBPACK FOOTER //
// ./src/pages/News/index.js